/**
 * @generated SignedSource<<fe571911745669516f11a74ed9e0569f>>
 * @relayHash 305bfba629f3fb1fcf0b98802abf2507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 69cd3740366e8d29b1c6a6a4156b7f2fcdf259b3466473ee99895304547b640a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useSuggestedTemplatesQuery$variables = {
  limit: number;
  sortingScheme?: string | null | undefined;
  spaceKey: string;
};
export type useSuggestedTemplatesQuery$data = {
  readonly allTemplates: {
    readonly nodes: ReadonlyArray<{
      readonly author: string | null | undefined;
      readonly blueprintModuleCompleteKey: string | null | undefined;
      readonly categoryIds: ReadonlyArray<string | null | undefined>;
      readonly contentBlueprintId: string | null | undefined;
      readonly darkModeIconURL: string | null | undefined;
      readonly description: string | null | undefined;
      readonly hasGlobalBlueprintContent: boolean;
      readonly hasWizard: boolean | null | undefined;
      readonly iconURL: string | null | undefined;
      readonly isFavourite: boolean | null | undefined;
      readonly isNew: boolean | null | undefined;
      readonly isPromoted: boolean | null | undefined;
      readonly itemModuleCompleteKey: string | null | undefined;
      readonly keywords: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly name: string | null | undefined;
      readonly recommendationRank: number | null | undefined;
      readonly styleClass: string | null | undefined;
      readonly templateId: string | null | undefined;
      readonly templateType: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useSuggestedTemplatesQuery = {
  response: useSuggestedTemplatesQuery$data;
  variables: useSuggestedTemplatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortingScheme"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      },
      {
        "kind": "Variable",
        "name": "sortingScheme",
        "variableName": "sortingScheme"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "PaginatedTemplateInfoList",
    "kind": "LinkedField",
    "name": "allTemplates",
    "plural": false,
    "selections": [
      {
        "concreteType": "TemplateInfo",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "templateId"
          },
          {
            "kind": "ScalarField",
            "name": "contentBlueprintId"
          },
          {
            "kind": "ScalarField",
            "name": "blueprintModuleCompleteKey"
          },
          {
            "kind": "ScalarField",
            "name": "itemModuleCompleteKey"
          },
          {
            "kind": "ScalarField",
            "name": "templateType"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "ScalarField",
            "name": "iconURL"
          },
          {
            "kind": "ScalarField",
            "name": "darkModeIconURL"
          },
          {
            "kind": "ScalarField",
            "name": "styleClass"
          },
          {
            "kind": "ScalarField",
            "name": "hasWizard"
          },
          {
            "kind": "ScalarField",
            "name": "isNew"
          },
          {
            "kind": "ScalarField",
            "name": "isPromoted"
          },
          {
            "kind": "ScalarField",
            "name": "isFavourite"
          },
          {
            "kind": "ScalarField",
            "name": "hasGlobalBlueprintContent"
          },
          {
            "kind": "ScalarField",
            "name": "categoryIds"
          },
          {
            "kind": "ScalarField",
            "name": "keywords"
          },
          {
            "kind": "ScalarField",
            "name": "recommendationRank"
          },
          {
            "kind": "ScalarField",
            "name": "author"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useSuggestedTemplatesQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSuggestedTemplatesQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "305bfba629f3fb1fcf0b98802abf2507",
    "id": "69cd3740366e8d29b1c6a6a4156b7f2fcdf259b3466473ee99895304547b640a",
    "metadata": {},
    "name": "useSuggestedTemplatesQuery",
    "operationKind": "query",
    "text": "query useSuggestedTemplatesQuery($spaceKey:String!,$sortingScheme:String,$limit:Int!){allTemplates(spaceKey:$spaceKey,sortingScheme:$sortingScheme,limit:$limit){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author}}}"
  }
};
})();

(node as any).hash = "0e72a917d2ed7c5fe874a55ae939d049";

export default node;
